var map = {
	"./bin.svg": "2d44",
	"./blank.svg": "ecd7",
	"./download.svg": "3c6f",
	"./edit.svg": "8dbe",
	"./excel.svg": "e3c6",
	"./eye.svg": "4024",
	"./file.svg": "17ae",
	"./folder.svg": "710e",
	"./image.svg": "44da",
	"./more.svg": "d076",
	"./move-right.svg": "f9c0",
	"./movie.svg": "f326",
	"./open.svg": "d3f3",
	"./pdf.svg": "5c48",
	"./pictures.svg": "2d28",
	"./powerpoint.svg": "c577",
	"./white/close.svg": "f698",
	"./white/download.svg": "cd4e",
	"./white/edit.svg": "6020",
	"./white/eye.svg": "38f8",
	"./word.svg": "e854"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "984b";